module.exports = __webpack_public_path__ + "static/media/create-link.59fc6ab3.svg";